import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../tools/AppConfig";
import Waiting from './../modules/waiting';
import Message from './errors/message';
import SimpleHeader from './../modules/simpleHeader';
import Card from './../modules/paymentMethods/card_partner';
import Wallet from './../modules/paymentMethods/wallet_pertner';
import Cash from './../modules/paymentMethods/cash_partner';
import Aman from './../modules/paymentMethods/aman_prem';
import Premium from './../modules/paymentMethods/premium';
import Valu from './../modules/paymentMethods/valu_partner';
import Jawwal from './../modules/paymentMethods/Jawwal';
import Delivery from './../modules/paymentMethods/delivery';
import amanImg from './../../statics/img/payment_methods_logos/logo_aman.png';
import masaryImg from './../../statics/img/payment_methods_logos/logo_masary.png';
import cashImg from './../../statics/img/payment_methods_logos/logo_cash.png';
import cardImg from './../../statics/img/payment_methods_logos/logo_mc_visa.png';
import walletImg from './../../statics/img/payment_methods_logos/logo_wallet.png';
import premiumImg from './../../statics/img/payment_methods_logos/logo_premium.gif';
import valuImg from './../../statics/img/payment_methods_logos/ValU.png';
import favicon from './../../statics/img/favicon.svg';
import favicon_jawwal from './../../statics/img/fav_icon.png';
import favicon_vodafone from './../../statics/img/vodafone.png';
import './../custom.css';
import './invoice.css';

import 'icheck/skins/all.css'; // or single skin css
import {Radio, RadioGroup} from 'react-icheck';

class invoice extends Component {
    constructor(props){
        super(props);
        this.state = {
            dataLoaded: false,
            userData: null,
            requestComplete: false,
            completeMessage: <h1>complete</h1>,
            currentMethod: '',
            MethodsName: {
                VPC: "Card",
                UIG: "Wallet",
                CASH: "Cash Collection",
                CAGG: "Accept Kiosk",
                PREMIUM: "Premium",
                VALU: "Valu",
                MPAY: "Jawwal Pay"
            },
            paymentMethodsDisable: false,
            deliveryDataCollected: false,
            deliveryData: {

            },
            //acq_partner
            acq_partner: true,
            styleData: this.props.styleData,

        };
        this.renderError  = this.renderError.bind(this);
        this.renderBody = this.renderBody.bind(this);
        this.paymentsMethods = this.paymentsMethods.bind(this);
        this.renderCurrentImg = this.renderCurrentImg.bind(this);
        this.disableAllPaymentMethods = this.disableAllPaymentMethods.bind(this);
        this.enableAllPaymentMethods = this.enableAllPaymentMethods.bind(this);
        this.handleMethodChange = this.handleMethodChange.bind(this);
        this.renderPaymentMethod = this.renderPaymentMethod.bind(this);
        this.currentPaymentMethodComponent = this.currentPaymentMethodComponent.bind(this);
        this.setDeliveryData = this.setDeliveryData.bind(this);
        this.setReqComplete = this.setReqComplete.bind(this);
        this.setPartnerColors = this.setPartnerColors.bind(this);
        this.loadData ();
    }
    loadData(){
        let token = this.props.token;
        let invoiceUrl = appConfig.getServerUrl() + '/invoice2/' + token;
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.get(
            invoiceUrl,
            config
        )
        .then((respond)=>{
            if(respond.data.error){
                this.setReqComplete({head: '', body: respond.data.error});
            }else{
                this.setState({userData: respond.data, dataLoaded: true},()=>{
                    let current_integrations_keys = [];
                    let all_integ_key_arr = Object.keys(this.state.userData.integration_ids);
                    for(let i=0; i< all_integ_key_arr.length;i++){
                        if(this.state.MethodsName[all_integ_key_arr[i]]){
                            current_integrations_keys.push(all_integ_key_arr[i]);
                        }
                    }
                    this.setState({currentMethod: current_integrations_keys[0]},()=>{
                        if(this.state.acq_partner){
                            this.setPartnerColors(this.state.styleData)
                        }else{
                            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                            link.rel="shortcut icon"
                            link.type = 'image/x-icon'
                            link.href= favicon;
                        }
                    })
                });
            }
        })
        .catch((err)=>{
            if(this.state.acq_partner){
                this.setPartnerColors(this.state.styleData)
            }else{
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.rel="shortcut icon"
                link.type = 'image/x-icon'
                link.href= favicon;
            }
            this.setReqComplete({head: 'Connection error', body:'Oops! Something went wrong. If this problem persists, please contact your service provider.'});
        });
    }
    setPartnerColors(data){
        let domain_name = window.location.hostname;
        if (domain_name === 'checkout.jawwalpay.ps' || domain_name === "stg.jawwalpay.ps") {
            setTimeout(()=>{
                document.querySelectorAll(".acq_partner").forEach(el => el.style.background = data.partner_css.header_background);
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.rel="shortcut icon"
                link.type = 'image/x-icon'
                link.href= favicon_jawwal;
            },100)
        }else if(domain_name === 'vodafonemerchants.paymobsolutions.com' || domain_name === "acceptstagingtestvodafone.paymobsolutions.com"){
            setTimeout(()=>{
                document.querySelectorAll(".acq_partner").forEach(el => el.style.background = data.partner_css.header_background);
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.rel="shortcut icon"
                link.type = 'image/x-icon'
                link.href= favicon_vodafone;
            },100)
        }else{
            setTimeout(()=>{
                document.querySelectorAll(".acq_partner").forEach(el => el.style.background = data.partner_css.header_background);
                // const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                // link.rel="shortcut icon"
                // link.type = 'image/x-icon'
                // link.href= favicon_jawwal;
            },100)
        }
    }
    paymentsMethods(){
        let current_integrations_keys = [];
        let all_integ_key_arr = Object.keys(this.state.userData.integration_ids);
        for(let i=0; i< all_integ_key_arr.length;i++){
            if(this.state.MethodsName[all_integ_key_arr[i]]){
                current_integrations_keys.push(all_integ_key_arr[i]);
            }
        }
        return(
            <RadioGroup name="radio" defaultValue={current_integrations_keys[0]} onChange = {this.handleMethodChange}>
                {current_integrations_keys.map((key, index) => {
                    return <Radio
                        key= {key}
                        value={key}
                        radioClass="iradio_square-blue"
                        increaseArea="20%"                                
                        label={"<span class='paymentMethodSpan'><span>" + this.state.MethodsName[key] + "</span>" + this.renderCurrentImg(key) + "</span>"}
                        disabled={this.state.paymentMethodsDisable}
                    />
                })} 
            </RadioGroup>
        );
    }
    renderCurrentImg(key){
        let allowedAggre = this.state.userData.allowed_aggregators;
        if(key === 'VPC'){
            return "<img class='paymentMethodImg' src=" + cardImg + " alt=" + key + " />"
        }else if(key === 'UIG'){
            return "<img class='paymentMethodImg' src=" + walletImg + " alt=" + key + " />"
        }else if(key === 'CASH'){
            return "<img class='paymentMethodImg' src=" + cashImg + " alt=" + key + " />"
        }else if(key === 'CAGG'){
            if(allowedAggre === "aman"){
                return "<img class='paymentMethodImg' src=" + amanImg + " alt=" + key + " />"
            }else if(allowedAggre === "masary"){
                return "<img class='paymentMethodImg' src=" + masaryImg + " alt=" + key + " />"
            }else if(allowedAggre === "aman/masary"){
                return "<img class='paymentMethodImg' src=" + amanImg + " alt=" + key + " /><img class='paymentMethodImg' src=" + masaryImg + " alt=" + key + " />"
            }else{
                return ''
            }
        }else if(key === 'PREMIUM'){
            return "<img class='paymentMethodImg' src=" + premiumImg + " alt=" + key + " />"
        }else if(key === 'VALU'){
            return "<img class='paymentMethodImg' src=" + valuImg + " alt=" + key + " />"
        }
        return ''
    }
    disableAllPaymentMethods(){
        this.setState({paymentMethodsDisable: true});
    }
    enableAllPaymentMethods(){
        this.setState({paymentMethodsDisable: false});
    }
    handleMethodChange(e){
        this.setState({currentMethod: e.target.value});
    }

    renderPaymentMethod() {
        let deliveryNeed = this.state.userData.order_delivery;
        if(deliveryNeed === false){
            return this.currentPaymentMethodComponent();
        }else if (deliveryNeed === true){
            if(this.state.deliveryDataCollected){
                return this.currentPaymentMethodComponent();
            }else{
                return <Delivery sourcePage='invoice' userData={this.state.userData} setDeliveryData={this.setDeliveryData}/>
            }
        }
        
    }
    setDeliveryData(data) {
        this.setState({deliveryDataCollected: true, deliveryData: {...data}});
    }
    setReqComplete(Message){
        this.setState({requestComplete: true, completeMessage: Message, dataLoaded: true});
    }
    currentPaymentMethodComponent() {
        let currentMethod = this.state.currentMethod;
        let deliveryNeed = this.state.userData.order_delivery;
        if( currentMethod === 'VPC'){
            if(deliveryNeed === false){
                return <Card
                    sourcePage='invoice'
                    deliveryNeed={false} deliveryData={null} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Card 
                    sourcePage='invoice'
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'UIG'){
            if(deliveryNeed === false){
                return <Wallet sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData} setReqComplete={this.setReqComplete}/>
            }else if (deliveryNeed === true){
                return <Wallet sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'CASH'){
            if(this.state.deliveryDataCollected){
                return <Cash sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else{
                return <Delivery sourcePage='invoice' userData={this.state.userData} setDeliveryData={this.setDeliveryData}/>
            }
            if(deliveryNeed === false){
                return <Wallet deliveryNeed={false} deliveryData={null} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else if (deliveryNeed === true){
                return <Wallet deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'CAGG'){
            if(deliveryNeed === false){
                return <Aman sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else if (deliveryNeed === true){
                return <Aman sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'PREMIUM'){
            if(deliveryNeed === false){
                return <Premium sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Premium sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'VALU'){
            if(deliveryNeed === false){
                return <Valu sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Valu sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'MPAY'){
            if(deliveryNeed === false){
                return <Jawwal sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Jawwal sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else{
            return <p>{this.state.MethodsName[this.state.currentMethod]}</p>
        }
    }
    renderError(){
        return ( 
            <div className="invoice">
                <SimpleHeader acq_partner={this.state.acq_partner} acq_partner_data={this.state.styleData}/>
                <Message body={this.state.userData.errorMessage} />
            </div>
        );
    }
    renderBody(){
        if(this.state.requestComplete){
            return ( 
                <div className="invoice">
                    <SimpleHeader acq_partner={this.state.acq_partner} acq_partner_data={this.state.styleData}/>
                    <div>
                        <Message head={this.state.completeMessage.head} body={this.state.completeMessage.body} />
                    </div>
                </div>
            );
        }else{
            return (
                <div className="invoice">
                    <SimpleHeader acq_partner={this.state.acq_partner} acq_partner_data={this.state.styleData}/>
                    <div className="right_col" role="main" id="content">
                        <div className="row" id="orderDetails">
                            <div className="col-md-5 col-md-offset-1 col-sm-6 col-xs-12">
                                <div className="x_panel errorTokenHide">
                                    <div className="x_title orderTitle">
                                        <h2 className="merchN">{this.state.userData.order_merchant_name}</h2>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="x_content">
                                        <div>
                                            <div id="choose_payment">
                                                <h3>Choose Payment Method</h3>
                                                {this.paymentsMethods()}
                                                
                                            </div>
                                        </div>
                                        <div className="col-md-12 col-sm-12 col-xs-12 wrapText">
                                            <h4 id="orderTitle" className="bl">Order {this.state.userData.order_id} Details</h4>
                                            <ul className="orderDetails">
                                                <li><span className="bl">Order Amount: </span> {this.state.userData.order_amount_egp + ' ' + this.state.userData.order_currency}</li>
                                                <li><span className="bl">Created at: </span> {this.state.userData.order_creation}</li>
                                                <li><span className="bl">Needs Delivery: </span> {this.state.userData.order_delivery? <span>Yes</span>:<span>No</span>}</li>
                                                <li><span className="bl">Order Name: </span> {this.state.userData.order_name}</li>
                                            </ul>
                                        </div>
    
                                        <div className="col-md-12 col-sm-12 col-xs-12 wrapText clientData hideAfterPay">
                                            <h4 className="bl">Client Details</h4>
                                            <ul className="clientDetails">
                                                <li><span className="bl">Full Name: </span> {this.state.userData.order_full_name}</li>
                                                <li><span className="bl">Phone Number: </span> {this.state.userData.order_phone}</li>
                                                <li><span className="bl">Email Address: </span> {this.state.userData.order_email}</li>
                                            </ul>
                                        </div>
                                        <br />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5 col-md-offset-1 col-sm-6 col-xs-12" id="payDiv">
                                {this.renderPaymentMethod()}                            
                            </div>
                        </div>
                    </div>
    
                </div>   
            );
        }
    }
    render(){
        //let userData = JSON.parse(localStorage.userData);
        return (
            <div>
                {this.state.dataLoaded?this.renderBody():<Waiting height='100vh' />}
            </div>
        );
    }
    
}

export default invoice;
